import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { useAuth } from '../../auth/AuthContext';

const ROLE_LABELS = {
    Admin: 'Administrador',
    Student: 'Estudiante',
    Teacher: 'Docente',
    CompanyAdmin: 'Empresa',
};

const PORTAL_ROUTES = {
    Admin: '/backoffice',
    Student: '/portal',
    Teacher: '/portal-doc',
    CompanyAdmin: '/portal-emp',
};

function HomeNav({ activeMenu, toggleMenu }) {
    const { user, activeRole, logout } = useAuth();
    const [isVisible, setIsVisible] = useState(true);

    const navRef = useRef(null);
    const btnToggleRef = useRef(null);
    
    // Referencia para leer el valor actual de activeMenu dentro de los event listeners
    const activeMenuRef = useRef(activeMenu);
    const toggleMenuRef = useRef(toggleMenu);

    useEffect(() => {
        activeMenuRef.current = activeMenu;
    }, [activeMenu]);

    useEffect(() => {
        toggleMenuRef.current = toggleMenu;
    }, [toggleMenu]);

    // Función unificada para cerrar el bloque desplegable
    const closeMobileMenu = () => {
        if (activeMenuRef.current === 'home') {
            toggleMenuRef.current('home'); // Usa la referencia más reciente del toggle
        }
    };

    useEffect(() => {
        let lastScrollY = window.scrollY;

        const controlNavbar = () => {
            const currentScrollY = window.scrollY;
            if (currentScrollY > lastScrollY && currentScrollY > 80) {
                setIsVisible(false);
                closeMobileMenu();
            }
            else if (currentScrollY < lastScrollY) {
                setIsVisible(true);
            }
            lastScrollY = currentScrollY;
        };

        window.addEventListener('scroll', controlNavbar);

        return () => {
            window.removeEventListener('scroll', controlNavbar);
        };
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            const isClickInsideNav = navRef.current && navRef.current.contains(event.target);
            const isClickOnToggle = btnToggleRef.current && btnToggleRef.current.contains(event.target);

            if (!isClickInsideNav && !isClickOnToggle) {
                closeMobileMenu();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <>
            <header className={`header-main-container ${!isVisible ? 'nav-hidden' : ''}`} style={{ position: 'relative' }}>
                
                <div className="nav-left-section">
                    <Link to="/" className="navbar-logo-desktop">
                        <img src="/img/somnus.webp" alt="Instituto de Capacitación" className="navbar-logo" />
                        <span className="logo-somnus">Somnus</span>
                    </Link>
                    <Link to="/" className="navbar-logo-movil">
                        <img src="/img/somnus-circulo.webp" alt="Instituto de Capacitación" />
                    </Link>
                </div>

                <nav ref={navRef} className={`nav-center-block ${activeMenu === 'home' ? 'open' : ''}`}>
                    <ul className="nav-row top-row">
                        <li><HashLink smooth to="/nosotros" onClick={closeMobileMenu}>Quienes somos</HashLink></li>
                        <li><Link to="/cursos" onClick={closeMobileMenu}>Cursos</Link></li>
                        <li><Link to="/validar-certificados" onClick={closeMobileMenu}>Validar certificados</Link></li>
                        <li><HashLink smooth to="/#asesorias" onClick={closeMobileMenu}>Asesorias</HashLink></li>
                        <li><HashLink smooth to="/#contacto" onClick={closeMobileMenu}>Contacto</HashLink></li>
                        <li><Link to="/noticias" onClick={closeMobileMenu}>Noticias</Link></li>
                        <li className="dropdown nav-item drop-panel block-none">
                            <a href="#!" className="dropdown-toggle-hover">
                                <span>{user && activeRole ? `Portal ${ROLE_LABELS[activeRole] || ''}` : 'Aula virtual'}</span>
                                <i className="ri-arrow-down-s-line arrow-down"></i>
                            </a>
                            <ul className="submenu dropdown-menu">
                                {user ? (
                                    <>
                                        <li className="nav-item">
                                            <Link to={PORTAL_ROUTES[activeRole] || "/"} className="dropdown-item a-nav">
                                                <i className="ri-dashboard-line pe-2"></i><span>Ir a mi portal</span>
                                            </Link>
                                        </li>
                                        <hr className="drop-divider-line" />
                                        <li className="nav-item">
                                            <a href="#!" onClick={(e) => { e.preventDefault(); logout(); }} className="dropdown-item a-nav text-danger">
                                                <i className="ri-logout-circle-r-line pe-2"></i><span>Cerrar sesión</span>
                                            </a>
                                        </li>
                                    </>
                                ) : (
                                    <>
                                        <li className="nav-item">
                                            <Link to="/login-est" className="dropdown-item a-nav">
                                                <i className="ri-circle-line"></i><span>Estudiantes</span>
                                            </Link>
                                        </li>
                                        <hr className="drop-divider-line" />
                                        <li className="nav-item">
                                            <Link to="/login-doc" className="dropdown-item a-nav">
                                                <i className="ri-circle-line"></i><span>Docentes</span>
                                            </Link>
                                        </li>
                                        <hr className="drop-divider-line" />
                                        <li className="nav-item">
                                            <Link to="/login-emp" className="dropdown-item a-nav">
                                                <i className="ri-circle-line"></i><span>Organización</span>
                                            </Link>
                                        </li>
                                        <hr className="drop-divider-line" />
                                        <li className="nav-item">
                                            <Link to="/login" className="dropdown-item a-nav">
                                                <i className="ri-circle-line"></i><span>Administrador</span>
                                            </Link>
                                        </li>
                                    </>
                                )}
                            </ul>
                        </li>
                        <li><Link to="/admision" className="btn-admission"><span>Admisión</span></Link></li>
                    </ul>
                </nav>
                <div className="nav-right-section">

                    <div className="menu-toggle-first">
                        <button ref={btnToggleRef} onClick={() => toggleMenu('home')} className="mobile-menu-btn">
                            <i className="ri-menu-line"></i>
                        </button>
                    </div>
                </div>

            </header>
            
        </>
    )
}
export default HomeNav;
